/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WalletControllerDtoTokenSendConditionsUpdateRequest model module.
 * @module model/WalletControllerDtoTokenSendConditionsUpdateRequest
 * @version 1.0
 */
class WalletControllerDtoTokenSendConditionsUpdateRequest {
    /**
     * Constructs a new <code>WalletControllerDtoTokenSendConditionsUpdateRequest</code>.
     * @alias module:model/WalletControllerDtoTokenSendConditionsUpdateRequest
     */
    constructor() { 
        
        WalletControllerDtoTokenSendConditionsUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoTokenSendConditionsUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoTokenSendConditionsUpdateRequest} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoTokenSendConditionsUpdateRequest} The populated <code>WalletControllerDtoTokenSendConditionsUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoTokenSendConditionsUpdateRequest();

            if (data.hasOwnProperty('xperTransferLimit')) {
                obj['xperTransferLimit'] = ApiClient.convertToType(data['xperTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('perTransferLimit')) {
                obj['perTransferLimit'] = ApiClient.convertToType(data['perTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('hvhMinimumWithdrawalBalance')) {
                obj['hvhMinimumWithdrawalBalance'] = ApiClient.convertToType(data['hvhMinimumWithdrawalBalance'], 'Number');
            }
            if (data.hasOwnProperty('hvhTransferAccount')) {
                obj['hvhTransferAccount'] = ApiClient.convertToType(data['hvhTransferAccount'], 'Number');
            }
            if (data.hasOwnProperty('xperUserOnetimeTransferLimit')) {
                obj['xperUserOnetimeTransferLimit'] = ApiClient.convertToType(data['xperUserOnetimeTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('perUserOnetimeTransferLimit')) {
                obj['perUserOnetimeTransferLimit'] = ApiClient.convertToType(data['perUserOnetimeTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('xperUserDailtyTransferLimit')) {
                obj['xperUserDailtyTransferLimit'] = ApiClient.convertToType(data['xperUserDailtyTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('perUserDailtyTransferLimit')) {
                obj['perUserDailtyTransferLimit'] = ApiClient.convertToType(data['perUserDailtyTransferLimit'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoTokenSendConditionsUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoTokenSendConditionsUpdateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} xperTransferLimit
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['xperTransferLimit'] = undefined;

/**
 * @member {Number} perTransferLimit
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['perTransferLimit'] = undefined;

/**
 * @member {Number} hvhMinimumWithdrawalBalance
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['hvhMinimumWithdrawalBalance'] = undefined;

/**
 * @member {Number} hvhTransferAccount
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['hvhTransferAccount'] = undefined;

/**
 * @member {Number} xperUserOnetimeTransferLimit
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['xperUserOnetimeTransferLimit'] = undefined;

/**
 * @member {Number} perUserOnetimeTransferLimit
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['perUserOnetimeTransferLimit'] = undefined;

/**
 * @member {Number} xperUserDailtyTransferLimit
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['xperUserDailtyTransferLimit'] = undefined;

/**
 * @member {Number} perUserDailtyTransferLimit
 */
WalletControllerDtoTokenSendConditionsUpdateRequest.prototype['perUserDailtyTransferLimit'] = undefined;






export default WalletControllerDtoTokenSendConditionsUpdateRequest;

